import * as React from 'react';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Link as RouterLink } from 'react-router-dom';

interface MyCardProps {
    id: number;
    name: string;
    description: string;
    url: string;
    path: string;
}

export default function MyCard(props: MyCardProps) {
    const { name, description, url, path } = props;
    return (
        <Card sx={{ maxWidth: 300, margin: 2, height: '100%', display: 'flex', flexDirection: 'column' }}>
            <CardMedia
                component="img"
                alt={`${name} educational resource preview`}
                height="300"
                image={url}
            />
            <CardContent sx={{ justifyContent: 'center', flexGrow: 1 }}>
                <Typography variant="h2" sx={{ fontSize: '1.15rem', fontWeight: 700, textAlign: 'center', mb: 1 }}>
                    {name}
                </Typography>
                <Typography variant="body2" sx={{ color: 'text.secondary', textAlign: 'center' }}>
                    {description}
                </Typography>
            </CardContent>
            <CardActions sx={{ justifyContent: 'center', pb: 2, pt: 1 }}>
                <Button 
                    variant="contained" 
                    color="primary"
                    size="medium"
                    endIcon={<ArrowForwardIcon />}
                    component={RouterLink}
                    to={path}
                    sx={{
                        px: 3,
                        py: 1,
                        borderRadius: 2,
                        textTransform: 'none',
                        fontWeight: 600,
                        boxShadow: 2,
                        transition: 'all 0.3s ease',
                        '&:hover': {
                            transform: 'translateY(-2px)',
                            boxShadow: 4,
                            backgroundColor: 'primary.dark',
                        }
                    }}
                >
                    View More
                </Button>
            </CardActions>
        </Card>
    );
}
